import { tns } from 'tiny-slider/src/tiny-slider';

class ImageSlider {
	constructor(el) {
		this.el = el;
        this.container = this.el.querySelector('.image-slider');

		const statsSlider = tns({
			container: '.image-slider',
			items: 1,
			slideBy: 1,
			mode: "gallery",
			autoplay: true,
			autoplayButtonOutput: false,
			speed: 400,
			controls: true,
			nav: true,
			navPosition: "bottom",
			// navContainer: this.nav
			// navContainer: '.pagination',
			// controlsContainer: '.pagination'
		});
    }
}

export default ImageSlider;